// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://${string}/api/pelias` | (string & {});
};

export const Layer = {
  address: 'address',
  street: 'street',
  country: 'country',
  region: 'region',
  macrocounty: 'macrocounty',
  county: 'county',
  locality: 'locality',
  localadmin: 'localadmin',
  borough: 'borough',
  neighbourhood: 'neighbourhood',
  coarse: 'coarse',
} as const;

export type Layer = (typeof Layer)[keyof typeof Layer];

export const CustomLayer = {
  airport_airfield: 'airport_airfield',
  art_by_the_wayside: 'art_by_the_wayside',
  automatic_bike_rental_station: 'automatic_bike_rental_station',
  automatic_e_bike_rental_station: 'automatic_e_bike_rental_station',
  award_winning_restaurant: 'award_winning_restaurant',
  bed_and_bike: 'bed_and_bike',
  bed_and_bike_sport: 'bed_and_bike_sport',
  bicycle_battery_charging_changing_station: 'bicycle_battery_charging_changing_station',
  bicycle_locker: 'bicycle_locker',
  bicycle_repair_service: 'bicycle_repair_service',
  bicycle_stand: 'bicycle_stand',
  bicycle_tube_station: 'bicycle_tube_station',
  bike_rental: 'bike_rental',
  building_monument: 'building_monument',
  camping: 'camping',
  castle_palace: 'castle_palace',
  church_monastery: 'church_monastery',
  craft_industrial_culture: 'craft_industrial_culture',
  e_bike_rental_station: 'e_bike_rental_station',
  entertainment: 'entertainment',
  ferry: 'ferry',
  landscape_park_nature: 'landscape_park_nature',
  leisure_transport_stop: 'leisure_transport_stop',
  mill_timber_framing: 'mill_timber_framing',
  mobility_station: 'mobility_station',
  museum_exhibition: 'museum_exhibition',
  nodenetwork: 'nodenetwork',
  observatory_planetarium: 'observatory_planetarium',
  offer_school_management: 'offer_school_management',
  other: 'other',
  parking_and_pick_up: 'parking_and_pick_up',
  plz_centers: 'plz_centers',
  project_agnh: 'project_agnh',
  railway_station: 'railway_station',
  rescue_point: 'rescue_point',
  school: 'school',
  school_route: 'school_route',
  service_partner_bicycle: 'service_partner_bicycle',
  sport_and_leisure_site: 'sport_and_leisure_site',
  stairs: 'stairs',
  swimming_pool_thermal_bath: 'swimming_pool_thermal_bath',
  tourism_service: 'tourism_service',
  tourist_info: 'tourist_info',
  warning: 'warning',
  water: 'water',
  zoo_animal_park: 'zoo_animal_park',
} as const;

export type CustomLayer = (typeof CustomLayer)[keyof typeof CustomLayer];

export const Source = {
  openstreetmap: 'openstreetmap',
  osm: 'osm',
  oa: 'oa',
  gn: 'gn',
  whosonfirst: 'whosonfirst',
  wof: 'wof',
} as const;

export type Source = (typeof Source)[keyof typeof Source];

export const CustomSource = {
  csv: 'csv',
  csv_plz: 'csv_plz',
  nrw: 'nrw',
  rlp: 'rlp',
  thr: 'thr',
  hessen: 'hessen',
  exportaddr: 'exportaddr',
} as const;

export type CustomSource = (typeof CustomSource)[keyof typeof CustomSource];

export type PlaceFeatureCollection = {
  type: 'FeatureCollection';
  features: Array<PlaceFeature>;
  bbox: BBox;
};

export type ReversePlaceFeatureCollection = {
  type: 'FeatureCollection';
  features: Array<ReversePlaceFeature>;
  bbox: BBox;
};

export type PlaceFeatureProperties = {
  id: string;
  gid: string;
  layer: Layer | CustomLayer;
  source: Source | CustomSource;
  source_id: string;
  name: string;
  postalcode: string;
  accuracy: string;
  country: string;
  country_gid: string;
  country_a: string;
  country_code: string;
  region: string;
  region_gid: string;
  region_a: string;
  macrocounty: string;
  macrocounty_gid: string;
  county: string;
  county_gid: string;
  county_a: string;
  localadmin: string;
  localadmin_gid: string;
  locality: string;
  locality_gid: string;
  neighbourhood: string;
  neighbourhood_gid: string;
  housenumber?: string;
  street?: string;
  label: string;
  addendum?: {
    [key: string]: unknown;
  };
};

export const PlaceFeatureType = { Feature: 'Feature' } as const;

export type PlaceFeatureType = (typeof PlaceFeatureType)[keyof typeof PlaceFeatureType];

export type PlaceFeatureGeometry = {
  type: 'Point';
  /**
   * longitude, latitude
   */
  coordinates: Array<number>;
};

export type PlaceFeature = {
  type: PlaceFeatureType;
  geometry: PlaceFeatureGeometry;
  properties: PlaceFeatureProperties;
  bbox?: BBox;
};

export type ReversePlaceFeature = {
  type: PlaceFeatureType;
  geometry: PlaceFeatureGeometry;
  properties: PlaceFeatureProperties & {
    distance: number;
    confidence: number;
  };
  bbox?: BBox;
};

/**
 * [min_lon, min_lat, max_lon, max_lat]
 */
export type BBox = [number, number, number, number];

/**
 * Latitude to reverse geocode.
 */
export type PointLat = number;

/**
 * Longitude to reverse geocode.
 */
export type PointLon = number;

/**
 * Partial address or place name.
 */
export type Text = string;

/**
 * Set the number of results returned
 */
export type Size = number;

/**
 * The sources parameter allows you to specify from which data sources you'd like to receive results
 */
export type Sources = Array<Source | CustomSource>;

/**
 * Specifies the layers to search in. Comma separated list of type layer.
 */
export type Layers = Array<Layer | CustomLayer>;

/**
 * Longitude to bias results toward.
 */
export type FocusPointLon = number;

/**
 * Latitude to bias results toward.
 */
export type FocusPointLat = number;

/**
 * Boundary min latitude to bias results toward.
 */
export type BoundaryRectMinLat = number;

/**
 * Boundary max latitude to bias results toward.
 */
export type BoundaryRectMaxLat = number;

/**
 * Boundary min longitude to bias results toward.
 */
export type BoundaryRectMinLon = number;

/**
 * Boundary max longitude to bias results toward.
 */
export type BoundaryRectMaxLon = number;

/**
 * Boundary circle longitude to bias results toward.
 */
export type BoundaryCircleLon = number;

/**
 * Boundary circle latitude to bias results toward.
 */
export type BoundaryCircleLat = number;

/**
 * Boundary circle radius to bias results toward.
 */
export type BoundaryCircleRadius = number;

/**
 * Boundary country to bias results toward. Comma separated list of alpha-2 or alpha-3 ISO-3166 country code
 */
export type BoundaryCountry = string;

/**
 * Boundary gid
 */
export type BoundaryGid = string;

export type V1SearchData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Partial address or place name.
     */
    text: string;
    /**
     * Set the number of results returned
     */
    size?: number;
    /**
     * The sources parameter allows you to specify from which data sources you'd like to receive results
     */
    sources?: Array<Source | CustomSource>;
    /**
     * Specifies the layers to search in. Comma separated list of type layer.
     */
    layers?: Array<Layer | CustomLayer>;
    /**
     * Latitude to bias results toward.
     */
    'focus.point.lat'?: number;
    /**
     * Longitude to bias results toward.
     */
    'focus.point.lon'?: number;
    /**
     * Boundary min latitude to bias results toward.
     */
    'boundary.rect.min_lat'?: number;
    /**
     * Boundary max latitude to bias results toward.
     */
    'boundary.rect.max_lat'?: number;
    /**
     * Boundary min longitude to bias results toward.
     */
    'boundary.rect.min_lon'?: number;
    /**
     * Boundary max longitude to bias results toward.
     */
    'boundary.rect.max_lon'?: number;
    /**
     * Boundary circle latitude to bias results toward.
     */
    'boundary.circle.lat'?: number;
    /**
     * Boundary circle longitude to bias results toward.
     */
    'boundary.circle.lon'?: number;
    /**
     * Boundary circle radius to bias results toward.
     */
    'boundary.circle.radius'?: number;
    /**
     * Boundary country to bias results toward. Comma separated list of alpha-2 or alpha-3 ISO-3166 country code
     */
    'boundary.country'?: string;
    /**
     * Boundary gid
     */
    'boundary.gid'?: string;
  };
  url: '/v1/search';
};

export type V1SearchResponses = {
  /**
   * GeoJSON FeatureCollection of results
   */
  200: PlaceFeatureCollection;
};

export type V1SearchResponse = V1SearchResponses[keyof V1SearchResponses];

export type V1ReverseData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Latitude to reverse geocode.
     */
    'point.lat': number;
    /**
     * Longitude to reverse geocode.
     */
    'point.lon': number;
    /**
     * Set the number of results returned
     */
    size?: number;
    /**
     * The sources parameter allows you to specify from which data sources you'd like to receive results
     */
    sources?: Array<Source | CustomSource>;
    /**
     * Specifies the layers to search in. Comma separated list of type layer.
     */
    layers?: Array<Layer | CustomLayer>;
    /**
     * Boundary circle radius to bias results toward.
     */
    'boundary.circle.radius'?: number;
    /**
     * Boundary country to bias results toward. Comma separated list of alpha-2 or alpha-3 ISO-3166 country code
     */
    'boundary.country'?: string;
    /**
     * Boundary gid
     */
    'boundary.gid'?: string;
  };
  url: '/v1/reverse';
};

export type V1ReverseResponses = {
  /**
   * GeoJSON FeatureCollection of results
   */
  200: ReversePlaceFeatureCollection;
};

export type V1ReverseResponse = V1ReverseResponses[keyof V1ReverseResponses];

export type V1AutocompleteData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Partial address or place name.
     */
    text: string;
    /**
     * Set the number of results returned
     */
    size?: number;
    /**
     * The sources parameter allows you to specify from which data sources you'd like to receive results
     */
    sources?: Array<Source | CustomSource>;
    /**
     * Specifies the layers to search in. Comma separated list of type layer.
     */
    layers?: Array<Layer | CustomLayer>;
    /**
     * Latitude to bias results toward.
     */
    'focus.point.lat'?: number;
    /**
     * Longitude to bias results toward.
     */
    'focus.point.lon'?: number;
    /**
     * Boundary min latitude to bias results toward.
     */
    'boundary.rect.min_lat'?: number;
    /**
     * Boundary max latitude to bias results toward.
     */
    'boundary.rect.max_lat'?: number;
    /**
     * Boundary min longitude to bias results toward.
     */
    'boundary.rect.min_lon'?: number;
    /**
     * Boundary max longitude to bias results toward.
     */
    'boundary.rect.max_lon'?: number;
    /**
     * Boundary circle latitude to bias results toward.
     */
    'boundary.circle.lat'?: number;
    /**
     * Boundary circle longitude to bias results toward.
     */
    'boundary.circle.lon'?: number;
    /**
     * Boundary circle radius to bias results toward.
     */
    'boundary.circle.radius'?: number;
    /**
     * Boundary country to bias results toward. Comma separated list of alpha-2 or alpha-3 ISO-3166 country code
     */
    'boundary.country'?: string;
    /**
     * Boundary gid
     */
    'boundary.gid'?: string;
  };
  url: '/v1/autocomplete';
};

export type V1AutocompleteResponses = {
  /**
   * GeoJSON FeatureCollection of results
   */
  200: PlaceFeatureCollection;
};

export type V1AutocompleteResponse = V1AutocompleteResponses[keyof V1AutocompleteResponses];

export type V1SearchStructuredData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Street address (may include house number).
     */
    address?: string;
    /**
     * Locality, city, or town.
     */
    locality?: string;
    /**
     * Region or state.
     */
    region?: string;
    /**
     * Country code.
     */
    country?: string;
    /**
     * Venue name (optional, for searching venues).
     */
    venue?: string;
    /**
     * Number of results to return.
     */
    size?: number;
  };
  url: '/v1/search/structured';
};

export type V1SearchStructuredResponses = {
  /**
   * GeoJSON FeatureCollection of results
   */
  200: PlaceFeatureCollection;
};

export type V1SearchStructuredResponse = V1SearchStructuredResponses[keyof V1SearchStructuredResponses];

export type V1PlaceData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Comma-separated list of Pelias gid identifiers.
     */
    ids: string;
    /**
     * If true, includes categories metadata.
     */
    categories?: boolean;
  };
  url: '/v1/place';
};

export type V1PlaceResponses = {
  /**
   * GeoJSON FeatureCollection of results
   */
  200: PlaceFeatureCollection;
};

export type V1PlaceResponse = V1PlaceResponses[keyof V1PlaceResponses];
